<template>
    <div>
        <MainModal 
            :show-modal="showModal"
            :title="`${action === 'add' ? 'Schedule a new' : 'Edit'} meeting`" 
            header-text-transform="none"
            @close="closeModal"
        >
            <template #body>
                <div class="">
                    <form class="max-h-600 pl--5 pr--5" @submit.prevent="">
                        <FormInput 
                            id="title" 
                            v-model="form.title"
                            size="sm"
                            info-type="required" 
                            label="Meeting title"
                        />

                        <div>
                            <FormLabel title="Description" />

                            <div 
                                v-show="showDesc" 
                                class="meet-item-desc form-control form__input form-control-sm form-control-border-solid form-control-bg-white mb--15"
                                @click="showDesc = !showDesc"
                            >
                                <TipTap v-model="form.description" />
                            </div>
                        </div>

                        <div class="row mb--15">
                            <div v-if="action === 'add'" class="form--control flex-1">
                                <FormLabel title="Select calendar integration" info-type="required" />
                                <CustomDropdown 
                                    id="calendarDropdown" 
                                    v-model="form.calendar" 
                                    :options="calendars"
                                    index-label="name"
                                    size="sm"
                                    class="text--capitalize"
                                    btn-classes="text--capitalize"
                                    :searchable="false"
                                    @select="v => form.calendar = v" 
                                />
                            </div>

                            <div class="form--control flex-1">
                                <FormLabel title="Meeting frequency" info-type="required" />
                                <CustomDropdown 
                                    id="repeatTimeDropdown" 
                                    v-model="form.recurrenceType" 
                                    :options="timeScheduleList"
                                    :searchable="false"
                                    list-class="list--dropdown--menu"
                                    size="sm"
                                    @select="v => form.recurrenceType = v" 
                                />
                            </div>
                        </div>

                        <div class="row mb--15">
                            <div class="flex-1">
                                <FormLabel title="Set time" info-type="required" />
                                <div class="flex flex-1 align-items-center justify-content-between">
                                    <div class="flex-1 mr--10">
                                        <v-date-picker 
                                            v-model="form.startDate" 
                                            class="text--sm" 
                                            :is-24="false" 
                                            is-required
                                            :min-date="new Date()"
                                        >
                                            <template #default="{ inputValue, togglePopover }">
                                                <input
                                                    class="px-2 py-1 border rounded due_date form-control form-control-sm text--sm"
                                                    :value="inputValue"
                                                    @click="togglePopover"
                                                >
                                            </template>
                                        </v-date-picker>
                                    </div>

                                    <div class="flex flex-2 align-items-center">
                                        <div class="flex align-items-center w--50">
                                            <CustomDropdown 
                                                id="countryDropdown" 
                                                v-model="form.startTime" 
                                                :options="timeSelection"
                                                :searchable="false"
                                                size="sm"
                                                class="mr--5 flex-1"
                                                list-class="list--dropdown--menu"
                                                @select="v => form.startTime = v" 
                                            />
                                            <CustomDropdown 
                                                id="timeDropdown" 
                                                v-model="form.startPeriod" 
                                                :options="['AM', 'PM']"
                                                :searchable="false"
                                                class="flex-1"
                                                size="sm"
                                                list-class="list--dropdown--menu"
                                                @select="v => form.startPeriod = v" 
                                            />
                                        </div>

                                        <div class="ml--10 mr--10 form-label form">
                                            to
                                        </div>
                                        <div class="flex align-items-center w--50">
                                            <CustomDropdown 
                                                id="countryDropdown" 
                                                v-model="form.endTime" 
                                                :options="timeSelection"
                                                :searchable="false"
                                                class="mr--5 flex-1"
                                                size="sm"
                                                @select="v => form.endTime = v" 
                                            />
                                            <CustomDropdown 
                                                id="timeDropdown" 
                                                v-model="form.endPeriod" 
                                                :options="['AM', 'PM']"
                                                :searchable="false"
                                                class="flex-1"
                                                size="sm"
                                                @select="v => form.endPeriod = v" 
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="form.recurrenceType !== 'Does not repeat'" class="m-w-100 mb--15">
                            <FormLabel title="End date" info-type="optional" />
                            <v-date-picker v-model="form.endDate" class="text--sm" :min-date="form.startDate">
                                <template #default="{ inputValue, togglePopover }">
                                    <input
                                        class="px-2 py-1 border rounded due_date form-control form-control-sm text--sm"
                                        :value="inputValue"
                                        :disabled="!form.startDate"
                                        @click="togglePopover"
                                    >
                                </template>
                            </v-date-picker>
                        </div>
                        
                        <div v-if="modalType === 'meetings'" class="form--control mb--15">
                            <FormLabel 
                                title="Link one or more clients" 
                                info-type="required"
                                info-text
                            />
                            <CustomDropdown 
                                id="attendeesDropdown" 
                                v-model="form.attendees" 
                                :options="clients"
                                index-label="email"
                                multiple
                                list-type="clients"
                                size="sm"
                                custom-text
                                list-class="list--dropdown--menu"
                                :loading="searchClientsLoading"
                                @search="searchClients" 
                                @select="selectAttendees" 
                                @remove="removeAttendeeSelection"
                            >
                                <template #text="{ item }">
                                    <div class="flex align-items-center">
                                        <IconSvg name="user" class="mr--5" />
                                        <p class="dropdown--item-label">
                                            {{ item.name }} - {{ item.email }}
                                        </p>
                                    </div>
                                </template>
                            </CustomDropdown>
                        </div>

                        <div class="form--control">
                            <FormLabel title="Timezone" info-type="required" />
                            <CustomDropdown 
                                id="countryDropdown" 
                                v-model="form.timeZone" 
                                :options="timeZones"
                                size="sm"
                                list-class="list--dropdown--menu"
                                :outer-loading="calendarLoading"
                                @search="searchTimeZones" 
                                @select="v => form.timeZone = v" 
                            />
                        </div>
                    </form>
                </div>
            </template>

            <template #footer>
                <div class="w-100 flex justify-content-end align-items-center">
                    <BaseButton
                        class="mr--5" 
                        label="Cancel"
                        variant="outline" 
                        :disabled="loading"
                        @submit="closeModal"
                    />
                    <BaseButton 
                        :label="`${action === 'add' ? 'Create' : 'Save'}`"
                        :loading="loading" 
                        :disabled="isBtnDisabled"
                        @submit="handleSubmit"                                       
                    />
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import countryList from "@/assets/js/countrycodes.json";
import MainModal from "./MainModal.vue";
import FormLabel from "../forms/FormLabel.vue";
import BaseButton from "../buttons/BaseButton.vue";
import FormInput from "../input/FormInput.vue";
import CustomDropdown from "../dropdowns/CustomDropdown.vue";
import { assembleQueryList } from "@/utils/helpers";
import { formatTimestampToTime } from "@/utils/date";
import { timeSelection, timeRepeatSchedule, socials } from "@/utils/dummy";
import IconSvg from "../icons/Icon-Svg.vue";
import TipTap from "../editor/TipTap.vue";

export default {
    name: "CreateMeeting",

    components: {
        MainModal,
        FormLabel,
        BaseButton,
        FormInput,
        CustomDropdown,
        IconSvg,
        TipTap,
    },

    props: {
        action: { type: String, default: "add" },
        selectedMeeting: { type: Object, default: () => {} },
        showModal: { type: Boolean, default: false },
        clientListProp: { type: Array, default: () => [] },
        modalType: { type: String, default: "meetings" },
        calendars: { type: Array, default: () => [] },
    },

    emits: ["create-complete", "close", "edit-complete", "resync"],

    data() {
        return {
            countryList,
            timeSelection,
            timeRepeatSchedule,
            socials,
            timeScheduleList: Object.keys(timeRepeatSchedule),
            form: {
                _id: "",
                title: "",
                attendees: [],
                startDate: null,
                endDate: null,
                location: "",
                description: "",
                calendar: undefined,
                startTime: "",
                endTime: "",
                startPeriod: "",
                endPeriod: "",
                recurrenceType: "",
                timeZone: "",
                providerKey: "",
                attendees: [],
                links: [{ name: "", url: "" }],
            },
            loading: false,
            clients: [],
            searchClientsLoading: false,
            repeatMeeting: false,
            timeZones: Intl.supportedValuesOf("timeZone"),
            calendarLoading: false,
            calendarLoadingErr: false,
            timeZoneOffset: "-12:00", 
            socialItemErrors: {},
            showDesc: false,
        };
    },

    computed: {
        isBtnDisabled() {
            if (
                !this.form.title || 
                !this.form.calendar || 
                !this.form.startDate || 
                !this.form.startTime || 
                !this.form.startPeriod || 
                !this.form.endTime || 
                !this.form.endPeriod || 
                !this.form.recurrenceType ||
                !this.form.attendees.length
            ) {
                return true;
            } else { 
                return false;
            }
        },

        userProfile() {
            return this.$store.getters["auth/profile"];
        },

        calendarData() {
            return this.$store.getters["integration/calendars"];
        },

        formattedStartTime() {
            if (!this.form.startDate || !this.form.startTime || !this.form.startPeriod) {
                return null;
            }
            
            // Parse the date
            const date = new Date(this.form.startDate);
            
            // Parse the time
            let [hours, minutes] = this.form.startTime.split(":").map(Number);
            
            // Adjust for AM/PM
            if (this.form.startPeriod === "PM" && hours < 12) {
                hours += 12;
            } else if (this.form.startPeriod === "AM" && hours === 12) {
                hours = 0;
            }
            
            // Set the hours and minutes
            date.setHours(hours, minutes, 0, 0);
            
            // Format as ISO string without the milliseconds and Z
            const isoDate = date.toISOString().replace(".000Z", "");
            
            // Append the timezone offset
            return `${isoDate}${this.timeZoneOffset}`;
        },
    },

    watch: {
        selectedMeeting: {
            handler(newVal) {
                if (newVal?._id) {
                    this.fillForm(newVal);
                }
            },
            immediate: true,
            deep: true,
        },

        calendarData(newVal) {
            if (newVal.id) {
                this.form.timeZone = newVal.timeZone;
            }
        },
        clientListProp: {
            handler(newVal) {
                if (newVal.length) {
                    this.form.attendees = this.clientListProp;
                }
            },
            immediate: true,
            deep: true,
        },
    },

    mounted() {   
        if (this.modalType === "meetings") {
            if (this.clientListProp.length) {
                this.clients = this.clientListProp;
            } else {
                this.searchClients();
            }
        } 
    },

    methods: {
        formatTimestampToTime,

        validateSocialItems() {
            let isInvalid = false;
            this.socialItemErrors = {};

            if (this.form.links?.length) {
                this.form.links.forEach((item, index) => {
                    if (!item.name.trim() || !item.url) {
                        this.socialItemErrors[index] = true;
                        isInvalid = true;
                    }   
                });
            }

            return isInvalid;
        },

        addSocialItem() {            
            const isEmpty = this.validateSocialItems();

            if (isEmpty) return;

            this.form.links.push({
                name: "",
                url: "",
            });
        },

        isSocialItemFilled(index) {
            if (this.socialItemErrors[index]) {
                return true;
            } else {
                return false;
            }
        },

        removeSocialItem(index) {
            const arr = this.form.links.filter((elem, idx) => {
                if (idx !== index) {
                    return idx !== index;
                }
            });
            
            this.form.links = arr;
        },

        closeModal() {
            this.resetForm();
            this.$emit("close");
        },

        resetForm() {
            this.form = {
                _id: "",
                title: "",
                attendees: [],
                startDate: null,
                endDate: null,
                location: "",
                description: "",
                calendarId: "",
                startTime: "",
                endTime: "",
                startPeriod: "",
                endPeriod: "",
                recurrenceType: "",
                timeZone: "",
                providerKey: "",
            };
        },

        fillForm(val) {
            const integrations = this.$store.getters["integration/integrations"] || [];
            const [startTime, startPeriod] = formatTimestampToTime(val?.startDate)?.split(" ");
            const [endTime, endPeriod] = formatTimestampToTime(val?.endDate)?.split(" ");

            this.form = {
                _id: val?._id || "",
                title: val?.title,
                startDate: val?.startDate || null,
                endDate: val?.endDate || null,
                location: val?.location || "",
                description: val?.description || "",
                attendees: val?.attendees || [],
                recurrenceType: val?.recurringEventType || "",
                providerKey: integrations.find(i => i.name === val?.providerKey),
                timeZone: val?.timeZone || "",
                startTime,
                endTime,
                startPeriod,
                endPeriod,
            };
        },

        formattedTime(selectedDate, endTime, endPeriod) {
            if (!selectedDate || !endTime || !endPeriod) {
                return null;
            }
            
            // Create a date object in the local timezone
            const date = new Date(selectedDate);
            
            // Parse the time
            let [hours, minutes] = endTime.split(":").map(Number);
            
            // Adjust for AM/PM
            if (endPeriod === "PM" && hours < 12) {
                hours += 12;
            } else if (endPeriod === "AM" && hours === 12) {
                hours = 0;
            }
            
            // Set the hours and minutes in the local timezone
            date.setHours(hours, minutes, 0, 0);
            
            // Get timezone offset from the date object for the user's timezone
            // This will be in minutes, so convert to hours:minutes format
            const tzOffset = -(date.getTimezoneOffset());
            const tzHours = Math.floor(Math.abs(tzOffset) / 60);
            const tzMinutes = Math.abs(tzOffset) % 60;
            const tzString = `${tzOffset >= 0 ? "+" : "-"}${tzHours.toString().padStart(2, "0")}:${tzMinutes.toString().padStart(2, "0")}`;
            
            // Format the date manually to ISO format
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            const hour = date.getHours().toString().padStart(2, "0");
            const minute = date.getMinutes().toString().padStart(2, "0");
            const second = date.getSeconds().toString().padStart(2, "0");
            
            // If you want to use the calculated timezone offset:
            return `${year}-${month}-${day}T${hour}:${minute}:${second}${tzString}`;
        },

        buildPayload() {
            const startDateTime = this.formattedTime(this.form.startDate, this.form.startTime, this.form.startPeriod);

            const payload = {
                eventPayload: {
                    summary: this.form.title,
                    location: this.form.location,
                    description: this.form.description,
                    attendees: this.form.attendees.map(item => ({ email: item.email, displayName: item.name })),
                    start: {
                        dateTime: startDateTime,
                        timeZone: this.form.timeZone,
                    },
                    end: {
                        timeZone: this.form.timeZone,
                    },
                },
                meetingPayload: {
                    recurringEventType: this.form.recurrenceType,
                    providerKey: this.form.calendar?.key,
                    timeZone: this.form.timeZone,
                    // links: this.form.links,
                },
            };

            if (this.form._id) {
                payload._id = this.form._id;
            }

            if (this.form.recurrenceType !== "Does not repeat") {
                payload.recurrence = [this.timeRepeatSchedule[this.form.recurrenceType]];
            }

            if (this.form.recurrenceType === "Does not repeat") {
                payload.eventPayload.end.dateTime = this.formattedTime(this.form.startDate, this.form.endTime, this.form.endPeriod);
            } else  if (this.form.recurrenceType === "Custom") {
                payload.eventPayload.end.dateTime = this.formattedTime(this.form.endDate, this.form.endTime, this.form.endPeriod);
            } else {
                payload.eventPayload.end.dateTime = startDateTime;
            }

            return payload;
        },

        async handleSubmit() {
            const payload = this.buildPayload();
            
            try {
                this.loading = true;                

                if (this.action === "edit") {
                    if (!this.form._id) {
                        throw new Error("Meeting id is required");
                    }

                    const resp = await this.$store.dispatch("meeting/updateMeeting", { payload, external: this.modalType === "clients" });
    
                    this.$toast.success("Meeting updated");
                    this.resetForm();
                    this.$emit("edit-complete", resp);
                } else {
                    const resp = await this.$store.dispatch("meeting/addMeeting", { payload, external: this.modalType === "clients" });

                    // save payload in local storage
                    // close modal and redirect user to re-authenticate 
                    // after re-authentication, fire add meeting request
                    // then redirect user to the updated meetings page
                    
                    this.$toast.success("New meeting created");
                    this.resetForm();
                    this.$emit("create-complete", resp);
                }
            } catch (error) {
                const errMsg = error?.response?.data?.message || error.message;

                if (error?.response?.data?.data?.url) {
                    this.$emit("resync", { payload, url });
                } else {
                    this.$toast.error(errMsg);
                }
            } finally {
                this.loading = false;
            }
        },

        selectAttendees(val) {
            const item = this.form.attendees.find(x => x?._id === val?._id);

            if (!item) {
                this.form.attendees = [ ...this.form.attendees, val];
            };
        },

        async searchClients(name) {
            try {
                this.searchClientsLoading = true;
                
                const buildResult = assembleQueryList({
                    page: 1,
                    name,
                });
                this.clients = await this.$store.dispatch("clients/fetchClients", { params: buildResult, refresh: true, external: true });
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;
                this.$toast.error(errMsg);
            } finally {
                this.searchClientsLoading = false;
            }
        },

        removeAttendeeSelection(item) {
            this.form.attendees = this.form.attendees.filter(x => x?._id !== item?._id);
        },

        searchTimeZones(query) {            
            if (query) {
                this.timeZones = this.timeZones.filter(x => x.toLowerCase().includes(query.toLowerCase()));
            } else {
                this.timeZones = Intl.supportedValuesOf("timeZone");
            }
        },

        async getDefaultTimeZone(integration) {
            try {
                this.calendarLoading = true;

                if (!integration.enabled) {
                    this.$toast.error("This integration is not enabled");
                    return;
                }

                const providerNameLowerCase = integration.name?.toLowerCase();
                const result = await this.$store.dispatch("integration/getPrimaryCalendar", providerNameLowerCase);
                this.form.timeZone = result?.timeZone;
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;
                this.$toast.error(errMsg);
            } finally {
                this.calendarLoading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.list--dropdown--menu {
    height: 100px;
}

.meet-item-desc {
    transition: opacity .15s ease-in-out, visibility .15s ease-in-out;
    transition: all 0.4s ease-in-out 0s, visibility 0s;
}
</style>